/**
 * Created by Klayer3
 */
import {isNull, isNullOrUndefined, isUndefined} from 'util';

//STANDARD FINGER DTO
export interface DTO {
  success: boolean;
  data: any;
  errorCode?: string;
  errorMessage?: string;
}

export interface Entity {
  id?: any;
}

export abstract class EntityBase implements Entity {
  id?: any;
  selected?: boolean;
  dateCreated?: Date;
  modifiedDate?: Date;
  modifiedBy?: string;
  isObsolete?: boolean;
  public toString() { return this.id + ''; }

  public equals(o: any): boolean {
    if ( isNull(o) || isUndefined(o)) {
      return false;
    }

    return o.id === this.id &&  o.toString() === this.toString() ;
  }
}

// ...Descr non ce piace: CustomEntityBase? CustomEntity? (Remo)
export class EntityDescr extends EntityBase {
  id?: any;
  public descr: string;
  public toString() {
    return this.descr;
  }
}

// ...CodeDescr non ce piace: CustomCodeEntityBase? CustomCodeEntity?(Remo)
export class CodeDescr extends EntityDescr {
  public code: string;
  /*public toString() {
    return this.code + ' - ' + this.descr;
  }*/

  public toString() {

    return this.descr;
  }
}


// MODEL --> User
// preso da postman restituito dal servizio login
// fixme per role sarebbe buono un array
/* per i wireframes attuali prevedo ruoli :
 * hostess --> accoglienza
 * nurse --> infermiere (Remo)
 * cashier --> cassiere
 * patient --> paziente
 * doctor --> medico
 * admin --> amministratore
 * ...
 * per nomi ecc.. il mio inglese lascia a desiderare quindi accetto volentieri correzioni :)
*/
export interface User {
  sub: string;
  userId: string;
  role: string;
  isActive: boolean;
  firstName: string;
  lastName: string;
  // fixme aggiunto volendo può essere derivato da role
  profile?: string;
  roles?: string[];
  warehouseId?:any;
}

//MODEL --> utente
export class UserAutocomplete extends EntityBase {
  name: string;
  surname: string;

  public toString() { return this.name + ' ' + this.surname; }
}

export class UserImpl extends EntityBase implements User {
  sub: string;
  userId: string;
  role: string;
  isActive: boolean;
  firstName: string;
  lastName: string;
  // fixme aggiunto volendo può essere derivato da role
  profile?: string;

  public toString() { return this.firstName + ' ' + this.lastName; }
}

export class Edition extends EntityBase {
  brandId?: number;
  enName?: string;
  abbreviation?: string;
  name?:string;

  get code() {
    return this.id;
  }
  set code(code: any) {
    this.id = code;
  }

  public toString() {
    return this.enName + (this.abbreviation ? ' ('+ this.abbreviation +')' : '' ) ;
  }
}



export class CardStocks extends EntityBase {
  cardName: string;
  cardEdition: string;
  avgPrice?: any;
  total?: number;
  temporary_quantity?: number;
  //il back va rivisto non ha molto senso quello che risponde
  warehouseStocks: {quantity:number, temporary_quantity:number,  warehouse_id: any}[];

}

export class Rarity extends EntityBase {
  description?: string;
  brandId: number;
  public toString(): string { return this.description ; }
}

export class ProductStructure extends EntityBase {
  name?: string;
  allFields: string[];
  fields: string[];
  stockfields: string[];
  public toString(): string { return this.name ; }
}

export class Category extends EntityBase {
  name?: string;
  public toString(): string { return this.name ; }
}

export class CategoryStructure implements Entity {
  id: string;
  brandId: number;
  categoryId: number;
  productStructureId: number;
}

export class Brand extends EntityBase {
  name?: string;
  code?: string;
  public toString(): string { return this.name ; }
}

export class Holo extends EntityBase {
  name?: string;
  code?: string;
  foil?: boolean;
  public toString(): string { return this.name ; }
}

export interface CardStocksDetails  {
  id: any;
  cardName: string;
  cardEdition: string;
  warehouseStockDetails: {
    warehouse_name: string,
    foil:{
      quantity: number,
      languages: [{
        quantity: number,
        language_name: string
        card_conditions: [
          {
            quantity: number,
            condition_name: string
          }]
      }
        ]
      card_conditions: [
        {
          quantity: number,
          condition_name: string
          languages: [{
            quantity: number,
            language_name: string
          }]
        }]
    },
    not_foil:{
      quantity: number,
      languages: [{
        quantity: number,
        language_name: string
        card_conditions: [
          {
            quantity: number,
            condition_name: string
          }]
      }
        ]
      card_conditions: [
        {
          quantity: number,
          condition_name: string
          languages: [{
            quantity: number,
            language_name: string
          }]
        }]
    }
  }[];

}

// MODEL --> session
export class Session extends EntityBase{
  name: string;
  userId: any;
  user: UserImpl;
  dateCreated: Date;
  modifiedDate: Date;
  approvalDeadlineDate?: Date;
  nRecords: number;
  state: string;
  stateId:number;
  sessionType: string;
  priority: any;
  systemSession: boolean;

  public toString(): string {
    return this.name;
  }
}

export interface MultipleValue {
  cardId?: Card[];
  languageId: Language[];
  editionId: Edition[];
  conditionId: Condition[];
  rarityId: any[];
}

export interface StockRuleMultipleValue{
  cardId?: ProductDetail[];
  editionId: Edition[];
  rarityId: any[];
  warehouseId: Warehouse[];


}

export class PriceRule extends EntityBase {

  status: any;
  cardId: any;
  product?: ProductDetail;
  rarityId?: number;
  editionName?: string
  editionId?: any;

  warehouse?: Warehouse;
  rarity: Rarity;
  price: number;
  suggestedPrice?: number;

  minRule?: boolean;
  maxRule?: boolean;
  maxPrice?: number;

  multipleValue: string;
  cardData?: {
    image?: string;
    categoryName : string;
    name: string;
    edition: string;
  };
  values: MultipleValue;
  combination?: StockCombination;

  expansion?: {
    id: any,
    enName: string;
  };

  get edition() {
    if( this.product &&  this.product.cardData && this.product.cardData.edition){
      return this.product.cardData.edition;
    }else if ( this.expansion && this.expansion.enName){
      return this.expansion.enName;
    }else if ( this.editionName){
      return this.editionName;
    }

    return '';
  }

  get editionIdentifier() {
    if ( this.expansion && this.expansion.id){
      return this.expansion.id;
    }else if ( this.editionId){
      return this.editionId;
    }

    return null;
  }
  constructor() {
    super();
    this.combination = new StockCombination();
  }
}


export class StockRule extends EntityBase {
  expansion?: {
    id: any,
    enName: string;
  };
  rarity: Rarity;
  rarityId?: number;
  product?: ProductDetail;
  cardName?: string;
  color?: string;
  format?: string;
  warehouseId?: number[] = [];
  warehouse?: Warehouse;
  minStockQuantity: number;
  maxStockQuantity: number;
  startDate?: Date;
  endDate?: Date;
  minPrice?: number;
  maxPrice?: number;
  preferences?: StockRulePreference[];
  combination?: StockCombination;


  //FIXME campi dubbi
  status: any;
  cardId: any;
  editionName?: string;
  editionId?: any;

  multipleValue: string;
  cardData?: {
    image?: string;
    categoryName : string;
    name: string;
    edition: string;
  };

  constructor() {
    super();
    this.combination = new StockCombination();
  }

  values: StockRuleMultipleValue;

  get edition() {
    if( this.product &&  this.product.cardData && this.product.cardData.edition){
      return this.product.cardData.edition;
    }else if ( this.expansion && this.expansion.enName){
      return this.expansion.enName;
    }else if ( this.editionName){
      return this.editionName;
    }

    return '';
  }

  get editionIdentifier() {
    if ( this.expansion && this.expansion.id){
      return this.expansion.id;
    }else if ( this.editionId){
      return this.editionId;
    }

    return null;
  }
}

export class StockRulePreference extends EntityBase {
  inked: boolean;
  altered: boolean;
  stamped: boolean;
  signed: boolean;
  foil: boolean;
  comments: string;
  conditionId: number;
  holoId: number;
  condition?: Condition;
  languageId?: any;
  language?: Language;
}

export class WarehouseMovement extends EntityBase {
  priority: any;
  quantity: number;
  conditionId: number;
  status: any;
  cardId: any;
  product?: ProductDetail;

  languageId: any;
  warehouseId: any;
  warehouseSession: Session;
  comments?: string;
  warehouseMovementNumber?: number;
  warehouseMovementRegistrationNumber?: number;
  counter: number;
  dateCreated: Date;
  warehouse?: Warehouse;
  nextMovement?: WarehouseMovement;
  previousMovement?: WarehouseMovement;
  order?: Order;
  combination?: StockCombination;

  get warehouseMovDescr(): String{
    let ret = this.warehouse.toString();
    if(!isNullOrUndefined(this.nextMovement) || !isNullOrUndefined(this.previousMovement)){
      if(!isNullOrUndefined(this.previousMovement)){
        ret += ' <- ' + this.previousMovement.warehouse.toString();
      }else {
        ret += ' -> ' + this.nextMovement.warehouse.toString();
      }

    }
    return ret;
  }

  get evadibile() {
    let ret = this.status ==2;
    return ret && (isNullOrUndefined(this.previousMovement) || this.previousMovement.status == 3);
  }

  get relatedWarehouseid() {
    if (!isNullOrUndefined(this.nextMovement)) {
      return this.nextMovement.warehouseId;
    } else if (!isNullOrUndefined(this.previousMovement)){
      return this.previousMovement.warehouseId;
    }

    return null;
  }
  groupMovements?: WarehouseMovement[];
  groupChild?:boolean;
  groupQty?:number;
}

export class WarehouseMovementSubmit extends EntityBase {
  quantity: number;
  condition: any;
  holo: any;
  signed: boolean;
  firstEdition: boolean;
  stamped: boolean;
  inked: boolean;
  altered: boolean;
  card_id: any;
  foil: boolean;
  comments?: string;
  language: string;
  session_id: any;
  warehouseFrom_id?: any;
  warehouseTo_id?: any;
}

// MODEL MAGAZZINO
export class Warehouse extends EntityBase {
  code?: string;
  name: string;
  refill?: boolean;
  virtual?: boolean;
  description?: string;

  /*public toString(): string {
    return this.code + ' - '+ this.name;
  }*/

  public toString(): string {
    return this.name;
  }

  constructor(name?: string) {
    super();
    this.name = name;
  }
}

export class Language extends EntityBase {
  cardLanguage: string;
  name: string;
  code?: string;
  /*public toString(): string {
    return this.code + ' - '+ this.cardLanguage;
  }*/

  public toString(): string {
    return this.name;
  }
}
export class Condition extends CodeDescr {
  description?: string
  shortDescr?: string;
  public toString(): string {
    return this.description;
  }
}
export class CardType extends CodeDescr {}

export interface CardDetailedInformation {
  id: string;
  cardName: string;
  cardEdition: string;
  cardImage: string;
  stockDetailsList: StockDetails[];
}


export interface StockDetails {
  warehouse_id: number;
  language_id: string;
  card_condition_id: number;
  foil: boolean;
  signed: boolean;
  stamped: boolean;
  inked: boolean;
  altered: boolean;
  real_qty: number;
  temp_qty: number;
  warehouse?: Warehouse;
  language?: Language;
  condition?: Condition;
}

export class Customer extends EntityBase{
  id?:any;
  name?: string;
  surname?: string;
  email?: string;
  public toString() {
    var ret = "";
    ["name", "surname", "email"].forEach(field => ret += isNullOrUndefined(this[field]) ? "" : this[field] + " ");
    return ret;
  }

}

export class Order extends EntityBase {
  warehouseId: any;
  priority: any;
  orderName: string;
  marketRefId?: any;
  marketReferenceStatus?: any;
  customerName: string;
  discount?: any;
  status: number;
  isObsolete?: boolean;
  orderDetails?: OrderDetail[];
  warehouse?: Warehouse;
  total?: number;
  partial?:number;
  itemsNumber?:number;
  note?: string;
  payed?: number;
  cash?: number;
  coupon?: number;
  customer?: Customer;
  size?: number;

  get customerDescr() {
    var ret = "";
    if( this.customer && this.customer.id){
      ret = this.customer.toString();
    } else {
      ret = this.customerName || '';
    }
    return ret;
  }

  public toString() { return this.orderName + ' ' + ( this.customerDescr )  + (this.warehouse ? ' ' +this.warehouse.name : ''); }
}

export class StockCombination extends EntityBase {
  foil: boolean;
  signed: boolean;
  firstEdition: boolean;
  stamped: boolean;
  inked: boolean;
  altered: boolean;
  shadowless: boolean;
  staff: boolean;
  language?: Language;
  holo?: Holo;
  condition?: Condition;
  get languageId(){
    return this.language != null ? this.language.id : null;
  }

  set languageId(id){
    if(!this.language){
      this.language = new Language();
    }
    this.language.id = id;
  }

  get conditionId(){
    return this.condition != null ? this.condition.id : null;
  }

  set conditionId(id){
    if(!this.condition){
      this.condition = new Condition();
    }
    this.condition.id = id;
  }
}

export class OrderDetail extends EntityBase {

  cardId: any;
  product?: ProductDetail;
  comments?: string;
  productDescription?: string;
  quantity?: any;
  price?: any;
  actualPrice?: any;
  warehouseId?: any;
  orderId : any;
  warehouse?: Warehouse;
  whMovements?: WarehouseMovement[];
  evadibile?: boolean;
  completato?: boolean;
  spedita?: boolean;
  trasferimento?: boolean;
  movStatus?: string;
  checked?: boolean;
  customer?: Customer;
  roundedPrice: number;
  combination?: StockCombination;

}

export class Notification extends EntityBase{
  status: string;
  refId: string;
  subject: string;
  content: string;
  dateCreated: Date;

  public toString() { return this.subject; }
}

export class PriceRuleNotification extends Notification {
  operation: string;
  priceRuleStatus: string;
  postponedTo: Date;
  eventDefinitions?: {[ priceRuleStatus: string]: string };
  priceRule?: PriceRule;
}
export class StockInventoryDefinition extends EntityBase {
  description: String;
  language: Language;
  minCondition: Condition;
  maxCondition: Condition;
  understockThreshold: number;
  overstockThreshold: number;
  foil?: boolean;
  firstEdition?: boolean;
  holo?: Holo;
  total: boolean;
}

export class StockInventoryProduct extends EntityBase {
   product: ProductDetail;
   stockInventoryDefinition: StockInventoryDefinition;
   quantity: number;
   stockStatus: string;
   nmEngPrice: number;

}

export class ProductDetail extends EntityBase{
  color: string;
  brand?: Brand;
  category?: Category;
  rarity?: any;
  number?: any;
  ean: string;

  cardData?: {
    image: string;
    name: string;
    edition: string;
  };
  expansion?: {
    id: any,
    enName: string;
  };

  get categoryName() {
    return this['category'] && this['category']['name'];
  }

  set categoryName(name: string) {
    if (this['category'] ) {
      this['category']['name'] = name;
    }
  }

  hot?: boolean;
  selected?: boolean;

  public toString() {
    if (this.cardData) return this.cardData.name + ' ' + this.cardData.edition;
  }

}

export class PriceInformationDTO {

  italianNearMintPrice: number = 0;
  italianNearMintFoilPrice: number = 0;
  englishNearMintPrice: number = 0;
  englishNearMintFoilPrice: number = 0;
}

export class ExecutionCounter {

  tasks: number = 0;
  errors: number = 0;
  executed: number = 0;
  percentage: number = 0;
}



export class Card extends ProductDetail {
  name: string;
  magicCard?: {id: any, cardSet: {name:string}};
  get edition(): string{

    if( this.expansion ){
      if( this.expansion ){
        return this.expansion.enName ;
      }
    }else if( this.magicCard ){
      if( this.magicCard.cardSet && this.magicCard.cardSet.name ){
        return this.magicCard.cardSet.name;
      }
    }
    return '';
  }
  expansion:
    {
      "id" :any,
      "enName" :string,

    };


  imageName?: string;
  languages?: any[];

  number?: string;

  get categoryName() {
    return this['category'] && this['category']['name'];
  }

  set categoryName(name: string) {
    if (this['category'] ) {
      this['category']['name'] = name;
    }
  }

  get english(){
    if(this.languages){
      let en = this.languages.find( l => l.language == 'English');
      return en ? en.name : '';
    }

    return '';
  }

}


export class Stock extends EntityBase{
  product?: ProductDetail;
  comments?: string;
  tempQuantity?: any;
  quantity?: any;
  giacenza?: number;
  actualPrice?: any;
  warehouseId?: any;
  warehouse: Warehouse;
  combination?: StockCombination;
  get price() {
    return this.actualPrice;
  }

  set price(price: number){
    this.actualPrice = price;
  }
}

export interface StockFilter {
  brandId?: any;
  categoryId?: any;
  cardId?: any;
  productName?: string;
  languageSearchId?: any;
  expansionId?: any;
  conditionId?: any;
  rarity?: number;
  holoId?: number;
  color?: string;
  minCardNumber?: string;
  maxCardNumber?: string;
  languageId?: any;
  foil?: boolean;
  comments?: string;
  signed?: boolean;
  stamped?: boolean;
  inked?: boolean;
  firstEdition?: boolean;
  altered?: boolean;
  warehouseId?: any;
  conditionOption?: string;
  minPrice?: any;
  maxPrice?: any;
  virtualWarehouse?: boolean;
}




















// WEBPACK FOOTER //
// ./src/app/core/entities/entities.ts